<div class="full-screen">

    <div class="d-flex flex-column justify-content-center body">
        <div class="heading white">
            <p class="fnt-60 fnt-weight-600">Elevate Your Cyber Journey!</p>
        </div>
        <div class="mt-3 fnt-16 fnt-weight-400 grey para">
            <p>Unlock Your Future - Connecting Talent with Opportunities</p>
            <p class="mt-2">2k+ Cyber Experts have joined us, now its your turn!</p>
        </div>
    </div>
</div>